import React from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";

function giftHeader(label) {
    if (label === "25%") return "Great start!";
    if (label === "50%") return "Halfway there!";
    if (label === "75%") return "Almost finished!";
    return "You are doing great";
}

function giftExplain(label) {
    if (label === "25%") return "You placed 25% of this puzzle.";
    if (label === "50%") return "You placed 50% of this puzzle.";
    if (label === "75%") return "You placed 75% of this puzzle.";
    return "";
}

export default function JigsawProgressGift({ gift, onClose }) {
    const open = Boolean(gift);
    const awarded = Math.max(0, Number(gift?.awarded) || 0);
    const balance = Math.max(0, Number(gift?.balance) || 0);
    const label = gift?.label || "";

    return (
        <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
            <DialogTitle>{giftHeader(label)}</DialogTitle>
            <DialogContent>
                <Typography variant="h5" sx={{ fontWeight: 800, color: "#2E7D32", mb: 1 }}>
                    +{awarded} {awarded === 1 ? "coin" : "coins"}
                </Typography>
                <Typography variant="body1">{giftExplain(label)}</Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mt: 1.5 }}>
                    {balance} coins
                </Typography>
            </DialogContent>
            <DialogActions sx={{ px: 3, pb: 2 }}>
                <Button variant="contained" onClick={onClose} sx={{ textTransform: "none", minHeight: 44 }}>
                    Continue
                </Button>
            </DialogActions>
        </Dialog>
    );
}
